import { Box, Theme, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import { useEffect } from "react";
import SectionWrapper from "../SectionWrapper/SectionWrapper";
import Map from "./Map";
import MapSwitcher from "./MapSwitcher";
import TrackingDetails from "./TrackingDetails";

const useStyles = makeStyles(theme => ({
  root: {
    height: 562,
    display: "flex",
    [theme.breakpoints.down("md")]: {
      height: "auto"
    }
  }
}));

export default function Main({
  data,
  dataLoaded,
  postalCode,
  postalAvailable,
  setTooltipOpen
}: {
  data: any;
  dataLoaded: boolean;
  postalCode: string | undefined;
  postalAvailable: boolean | undefined;
  setTooltipOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const classes = useStyles();

  const screenSm: boolean = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down("md")
  );

  useEffect(() => {
    setMapVisible(false);
  }, [screenSm]);

  const [mapVisible, setMapVisible] = useState<boolean>(false);

  const toggleMap = () => {
    setMapVisible(mapVisible => !mapVisible);
  };
  console.log(screenSm, postalCode);

  return (
    <SectionWrapper>
      <div className={classes.root}>
        {!mapVisible && <TrackingDetails data={data} dataLoaded={dataLoaded} />}
        {(!screenSm || mapVisible) && (
          <Map
            data={data}
            postalCode={postalCode}
            toggleMap={toggleMap}
            postalAvailable={postalAvailable}
            dataLoaded={dataLoaded}
            setTooltipOpen={setTooltipOpen}
          />
        )}
        {screenSm && !mapVisible && (postalCode || !postalAvailable) && (
          <MapSwitcher
            toggleMap={toggleMap}
            isLive={
              !["skipped", "finished"].includes(data.stop_status) &&
              data?.driver_location?.lat &&
              data?.driver_location?.lng
            }
          />
        )}
      </div>
    </SectionWrapper>
  );
}
